import * as React from "react";
import styled from "styled-components";
import { useSize } from "@lkf/hooks";

const Layout = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  bottom: 8px;
  width: 600px;
`;

const NavigationSwitcherLayout = ({ children }) => {
  const ref = React.useRef();
  const { height } = useSize(ref);
  return (
    <Layout ref={ref}>
      {children(height === Infinity ? 500 : height - 80)}
    </Layout>
  );
};

export default NavigationSwitcherLayout;
